<template>
  <div class="grid justify-content-center">
    <div class="col-12 sm:col-8 md:col-5 comp-grid">
      <div class="mb-2">
        <Button
          icon="pi pi-arrow-left"
          class="p-button-sm p-button-rounded px-4"
          @click="
            () => {
              $router.go(-1);
            }
          "
        />
      </div>
      <Message
        @close="errorMsg = null"
        class="fadeinUp"
        v-if="errorMsg"
        severity="error"
        key="error"
        >{{ errorMsg }}</Message
      >
      <div class="card shadow-3">
        <div class="my-3">
          <div class="text-2xl font-bold">Password Reset</div>
          <small class="text-500">
            Please provide the valid email address you used to register
          </small>
        </div>
        <Message severity="success" v-if="sentMsg">{{ sentMsg }}</Message>
        <form ref="observer" tag="form" @submit.prevent="sendEmail()">
          <div class="grid align-items-center justify-content-between">
            <div class="col-12 md:col-9">
              <InputText
                class="w-full"
                v-model="formData.email"
                placeholder="Email"
                required
                type="email"
              />
            </div>
            <div class="col-12 md:col-3">
              <Button
                :loading="saving"
                type="submit"
                label="Send"
                class="w-full p-button-rounded"
              />
            </div>
          </div>
        </form>
        <hr />
        <div class="text-primary">
          A link will be sent to your email containing the information you need
          for your password
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data: function () {
    return {
      formData: {
        email: "",
      },
      saving: false,
      errorMsg: null,
      sentMsg: null,
    };
  },
  methods: {
    async sendEmail() {
      this.saving = true;
      this.errorMsg = null;
      this.$api.post("auth/forgotpassword", this.formData).then(
        (response) => {
          this.saving = false;
          this.sentMsg = response.data;
        },
        (request) => {
          this.saving = false;
          this.sentMsg = null;
          this.errorMsg =
            request?.response?.data || "Unable to complete request";
        }
      );
    },
  },
};
</script>
